import React from "react";
import { Img } from "../../components";
import SendNewOfferForm from "components/SendNewOfferForm";

export default function SendNewOfferMobilePopup({
  isOpen = true,
  isRejectedOrApproved,
  onClose,
  car,
  currentUser,
  offer,
  onUpdateOffer,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[1000011] flex items-center justify-center bg-black/50 p-2 sm:p-4"
      dir="rtl"
      onClick={onClose}
      style={{backgroundColor:'black'}}
    >
      {/* Card */}
      <div
        className="
          relative w-full max-w-[360px] h-[96vh]
          rounded-[20px] bg-white shadow-xl border border-[#d9d9d9]
          overflow-hidden
        "
        dir="ltr"
        style={{backgroundColor: "white"}}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="relative flex items-center justify-center px-4 pt-3 pb-2 border-b border-[#f0f0f0]">
          <button
            type="button"
            onClick={onClose}
            aria-label="סגור"
            className="
              absolute left-3 top-3
              h-7 w-7 rounded-full
              flex items-center justify-center
              text-[#a3a3a3] hover:bg-gray-100
            "
          >
            x
          </button>

    
        </div>

        {/* Scrollable body */}
        <div className="h-[calc(96vh-56px)] overflow-y-auto px-2 pb-2">
          {/* אם בתוך SendNewOfferForm יש כבר כותרת/מעטפת,
              אפשר להעביר variant="panel" כדי שיציג רק תוכן */}
          <SendNewOfferForm
            isRejectedOrApproved={isRejectedOrApproved}
            car={car}
            currentUser={currentUser}
            offer={offer}
            onUpdateOffer={onUpdateOffer}
            onClose={onClose}
            variant="panel" // חשוב אם בנית שם popup/panel
          />
        </div>
      </div>
    </div>
  );
}
